export default (that) => [
  {
    field: 'seq',
    width: 30,
    align: 'center',
    fixed: 'left',
    type: 'seq',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzSkuStoreNo') || '亚马逊SKU',
    field: 'amzSkuStoreNo',
    align: 'center',
    minWidth: 160,
  },
  {
    title: that.$l('table_label_storeName') || '店铺',
    field: 'storeName',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_operateName') || '负责运营',
    field: 'operateName',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutDays') || '断货天数',
    field: 'stockOutDays',
    align: 'center',
    minWidth: 90,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_stockOutPeriod') || '监控周期',
    field: 'stockOutPeriod',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
  },
]
